import Phaser from 'phaser';
import Game from './Game';
import ABCyaPhaser from '@abcya/abcya_phaser';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import gameData, { GameShortNames } from '../gameData';
import TitleSanta from '../game/TitleSanta';
import SnowMaker from '../game/SnowMaker';
import { playJingle, setup } from '../SoundManager';

export default class Intro extends Phaser.Scene {
  static get KEY() { return 'Intro'; }

  create() {
    this.cameras.main.setBackgroundColor(0x5ecceb);

    setup(this);

    playJingle();

    const h = this.scale.height;
    this.bgSnow = this.add.rectangle(0, 0, this.scale.width, this.scale.height, 0xFFFFFF).setOrigin(0);
    this.bgSnow.y = this.scale.height - (h - 516);

    this.candyCane = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._TitleCane, this).setOrigin(0);
    this.present2 = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._TitlePresent_2, this).setOrigin(0);
    this.present3 = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._TitlePresent_3, this).setOrigin(0);
    this.present1 = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._TitlePresent_1, this).setOrigin(0);

    this.santa = new TitleSanta(this);
    this.add.existing(this.santa);

    this.title1 = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._Title_1, this).setOrigin(0);
    this.title2 = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._Title_2, this).setOrigin(0);

    this.doIntro();

    this.snowContainer = this.add.container();
    this.snow = new SnowMaker(this, 100, 4, this.snowContainer);

    this.btnGo = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._BtnGo, this).setScale(0);
    this.btnGo.x = this.scale.width / 2;
    this.btnGo.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => { this.clickGo(); });
  }

  doIntro() {
    let startx = 0;
    let starty = 0;
    let destx = 0;
    let desty = 0;

    startx = 373;
    destx = 373;
    starty = -this.title2.getBounds().height;
    desty = 217;
    this.title2.x = startx;
    this.title2.y = starty;
    ABCyaPhaser.Tweens.addTween(this.title2, 800, { y: desty }, Phaser.Math.Easing.Linear);

    startx = 273;
    destx = 273;
    starty = -this.title1.getBounds().height;
    desty = 94;
    this.title1.x = startx;
    this.title1.y = starty;
    ABCyaPhaser.Tweens.addTween(this.title1, 800, { y: desty, delay: 500 }, Phaser.Math.Easing.Linear);

    startx = 744;
    destx = 744;
    starty = -this.present1.getBounds().height;
    desty = 599;
    this.present1.x = startx;
    this.present1.y = starty;
    ABCyaPhaser.Tweens.addTween(this.present1, 1000, { y: desty, delay: 300 }, Phaser.Math.Easing.Quadratic.In, () => {
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._lg_snow, this);
    });

    startx = 832;
    destx = 832;
    starty = -this.present2.getBounds().height;
    desty = 585;
    this.present2.x = startx;
    this.present2.y = starty;
    ABCyaPhaser.Tweens.addTween(this.present2, 1000, { y: desty, delay: 1000 }, Phaser.Math.Easing.Quadratic.In, () => {
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._lg_snow, this);
    });

    startx = 671;
    destx = 671;
    starty = -this.present3.getBounds().height;
    desty = 560;
    this.present3.x = startx;
    this.present3.y = starty;
    ABCyaPhaser.Tweens.addTween(this.present3, 1000, { y: desty, delay: 1500 }, Phaser.Math.Easing.Quadratic.In, () => {
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._sm_snow, this);
    });

    destx = 134;
    startx = 134;
    starty = -this.candyCane.getBounds().height;
    desty = 330;
    this.candyCane.x = startx;
    this.candyCane.y = starty;
    ABCyaPhaser.Tweens.addTween(this.candyCane, 1000, { y: desty, delay: 1500 }, Phaser.Math.Easing.Quadratic.In, () => {
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._sm_snow, this);
    });

    startx = 207;
    destx = 207;
    starty = -this.santa.getBounds().height;
    desty = 376;
    this.santa.x = startx;
    this.santa.y = starty;
    ABCyaPhaser.Tweens.addTween(this.santa, 1000, { y: desty, delay: 180 }, Phaser.Math.Easing.Quadratic.In, () => {
      this.santaLanded();
    });

    if (gameData.game === GameShortNames.jr) {
      this.jrSprite = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._JR, this).setOrigin(0);
      this.jrSprite.x = this.title1.x + this.title1.getBounds().width;
      this.jrSprite.y = -200;

      ABCyaPhaser.Tweens.addTween(this.jrSprite, 600, { y: 96, delay: 1300 }, Phaser.Math.Easing.Linear);
    }

    ABCyaPhaser.Tweens.addTween(this.bgSnow, 70000, { y: 104 }, Phaser.Math.Easing.Linear);
  };

  santaLanded() {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._lg_snow, this);
    this.santa.doWave();
    this.showGo();
  };

  playSound(snd) {
    ABCyaPhaser.Audio.playOneShot(snd, this);
  };

  showGo() {
    this.btnGo.y = this.scale.height - 160;

    ABCyaPhaser.Tweens.addTween(this.btnGo, 240, { scaleX: 1.6, scaleY: 1.6, alpha: 1 }, Phaser.Math.Easing.Quadratic.In, () => {
      ABCyaPhaser.Tweens.addTween(this.btnGo, 320, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Quadratic.Out, () => {
        this.btnGo.setInteractive({ cursor: 'pointer' });
      });
    });
  };

  clickGo() {
    this.scene.start(Game.KEY);
  };

  update(time, delta) {
    const dt = delta / 1000;
    this.snow.tick(dt);
  };
}